import Vue from 'vue';
import Vuetify from 'vuetify/lib';

// Translation provided by Vuetify (typescript)
import es from 'vuetify/src/locale/es.ts'
import pt from 'vuetify/src/locale/pt.ts'

Vue.use(Vuetify);

export default new Vuetify({
    lang: {
      locales: { es, pt },
      current: 'es',
    },
    icons: {
      iconfont: 'mdi',
    },
    theme: {
      dark: false
    },
});
